<bfx-close [disabled]="unrecoverableError === false"></bfx-close>
<div class="auth__login__panel" nativeDesktopClass="desktop">
  <div fxLayout="row" class="auth__login__panel__header">
    <div fxFlex="50" class="auth__login__panel__header-logo">
      <bfx-logo-svg></bfx-logo-svg>
    </div>
    <div fxFlex="45" class="auth__login__panel__header-title">{{ frameTag }}</div>
    <div fxFlex="5" class="auth__login__panel__header-status">
      <div
        class="status"
        [ngClass]="{
          none: connectionStatus === 0,
          online: connectionStatus === 1 || connectionStatus === 5,
          offline: connectionStatus === 2 || connectionStatus === 4,
          error: connectionStatus === 3
        }"
      >
        <span
          [bfxTooltip]="connectionStatusText"
          tooltipPosition="top"
          tooltipStyleClass="auth__login__panel__header-tooltip"
        ></span>
        <!--  -->
      </div>
    </div>
  </div>

  <div class="auth__login__panel__body">
    <bfx-progressbar [value]="progress.visual.value"> </bfx-progressbar>
    <div [innerHTML]="progress.log.text"></div>

    <div class="loader-unrecoverable-error" *ngIf="unrecoverableError">
      Connection Error: In order to access OMS you need to
      <a role="button" (click)="reroute()">Sign-in again</a>.
    </div>
  </div>

  <div class="auth__login__panel__footer">
    <p class="copyright">&copy; BarracudaFX</p>
  </div>
</div>
